import { useSearchParams } from "react-router-dom";

import useSWR from "swr";
import { swrKey } from "@/lib/swr";
import { VersionList } from "./version-card";
import type { Version } from "@/types/domain";
import { allStateCodes } from "@/constants/version-state";
import { useVersionStates } from "@/hooks/version-states";

// By default only show "in-progress" versions. The state catalog is
// DB-managed (Admin can add custom states), so the default filter is
// "every catalog state except these" rather than an allowlist — otherwise
// versions moved onto a custom state silently drop off this list.
// Exclusions: 190 审核中 (own Audits tab) and the terminal-ish
// rejected / archived / offline / discarded. URL ?state= takes precedence.
const NON_DEFAULT_STATES = [190, 260, 270, 271, 280];

const Index = () => {
  const [searchParams] = useSearchParams();
  const catalog = useVersionStates();
  const { state, ...params } = Object.fromEntries(searchParams.entries());
  // Before the catalog arrives, fall back to the built-in codes (same set).
  const states = state
    ? state.split(",").map((s) => parseInt(s, 10))
    : (catalog?.length ? catalog.map((r) => r.code) : allStateCodes()).filter(
        (c) => !NON_DEFAULT_STATES.includes(c)
      );

  // The number of in-progress versions is limited; fetch all at once without pagination.
  const { data, isLoading } = useSWR<{ data: Version[]; total: number }>(
    swrKey("/versions", { ...params, state: states, pageIndex: 0, pageSize: 500 })
  );

  const versions: Version[] = data?.data ?? [];

  return (
    <div className="flex flex-col gap-4">
      <VersionList versions={versions} isLoading={isLoading} />
    </div>
  );
};

export default Index;
